import { render, staticRenderFns } from "./SendAction.vue?vue&type=template&id=c1319996&scoped=true&"
import script from "./SendAction.vue?vue&type=script&lang=js&"
export * from "./SendAction.vue?vue&type=script&lang=js&"
import style0 from "./SendAction.vue?vue&type=style&index=0&id=c1319996&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1319996",
  null
  
)

export default component.exports